module.exports = __webpack_public_path__ + "static/media/img_workshop_optimized.28fed0ae.jpg";